import { Component, OnDestroy, OnChanges, AfterViewInit, ViewChild, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs/Rx';
import { NavigationService } from '../../services/navigation.service';
import { MessageService } from 'base';
import { NetFacadeService } from '../../services/netfacade.service';
import { AgentDto } from 'UvExplorerServer.Dtos.TS/Agents';
import { ChangeableContainer } from '../ChangeableContainer';
import { DiscoveryListComponent } from '../discoverylist/discoverylist.component';
import { AgentSettingsComponent } from '../agent-settings/agent-settings.component';
import { NvtnPrtgExportConfigComponent } from '../nvtn-prtg-export-config/nvtn-prtg-export-config.component';
import { IdentityService } from '../../../identity';
import { DevicesComponent } from 'netview';
import { ReportsComponent } from 'infosets';


@Component({
	selector: 'agent',
	templateUrl: './agent.component.html'
})
export class AgentComponent extends ChangeableContainer implements OnChanges, OnDestroy, AfterViewInit {

	public agent: AgentDto;
	private locationChangedSub: Subscription;
	public selectedTab: number;

	@ViewChild(DevicesComponent)
	public devices: DevicesComponent;

	@ViewChild(ReportsComponent)
	public reports: ReportsComponent;

    @ViewChild(AgentSettingsComponent)
	public agentSettings: AgentSettingsComponent;

    @ViewChild(DiscoveryListComponent)
	public discoveryList: DiscoveryListComponent;

    @ViewChild(NvtnPrtgExportConfigComponent)
	public prtgExport: NvtnPrtgExportConfigComponent;

	public readonly DevicesTabIndex = 0;
	public readonly ReportsTabIndex = 1;
	public readonly EventsTabIndex = 2;
	public readonly MonitorsTabIndex = 7;

	constructor(
		navService: NavigationService,
		messageService: MessageService,
		private netFacadeService: NetFacadeService,
		private identityService: IdentityService) {

		super(navService, messageService);

		this.selectedTab = 0;

		this.getCurrentAgent();

		this.locationChangedSub = this.navService.onLocationChanged.subscribe(() => {
			this.getCurrentAgent();
		});
	}

	public ngOnChanges(changes: SimpleChanges): void {
		return;
	}

	public ngAfterViewInit(): void {
		this.children = [
			this.agentSettings,
			this.prtgExport,
		];
	}

	public ngOnDestroy(): void {
		if (this.locationChangedSub) {
			this.locationChangedSub.unsubscribe();
			this.locationChangedSub = undefined;
		}
	}

	public onDump(): void {
		this.netFacadeService.dumpAgentConfig(this.agent.Guid).subscribe(
			(result: boolean) => {
				if (result) {
					this.messageService.displayInfoMessage("Dump completed");
				} else {
					this.messageService.displayErrorMessage("Dump failed");
				}
			},
			(error: any) => {
				this.messageService.displayErrorMessage("Dump failed");
			});
	}

	public get isLoggedIn(): boolean {
		return this.identityService.isLoggedIn;
	}

	private getCurrentAgent(): void {
		this.agent = new AgentDto();

		if (this.navService.location.hasAgentGuid) {
			let agentGuid = this.navService.location.agentGuid;
			this.agent = this.netFacadeService.findAgent(agentGuid);
		}
	}

	public isSaveEnabled(): boolean {
		return (this.agent && (this.agent.HasChanges || this.tempChanges));
	}

	protected save(): void {
		this.messageService.displayInfoMessage(`Saving changes to agent '${this.agent.Name}'`);
		// Make local copy of agent reference because the agent loaded in this component
		// might change before the asynchronous save operation completes
		let agent: AgentDto = this.agent;
		this.netFacadeService.updateAgent(agent).subscribe(
			(result: AgentDto) => {
				agent.HasChanges = false;
			},
			(error: any) => {
				this.messageService.displayErrorMessage("Saving agent changes failed");
			});
	}
	
	public onTabChange(event: any): void {
		this.selectedTab = event.index;

		switch (this.selectedTab) {	
			case this.DevicesTabIndex:
				if (this.devices) {
					this.devices.reloadDeviceList();
				}
				break;
			case this.ReportsTabIndex:
				if (this.reports) {
					this.reports.reloadReport();
				}
				break;
		}
	}

}